module.exports = __webpack_public_path__ + "img/184.105380dc.jpg";